module.exports = __webpack_public_path__ + "static/media/mooniswap.0fbd188d.png";